import { Searches } from "../models/shipeezi.table";

export const sequelizeOperatorsAliases = {
  like: "$like",
};

const getRelatedSearch = (
  searches?: Searches,
  relatedTable?: string,
  overrideColumn?: string,
  isLikeOperator?: boolean
) => {
  if (!searches) return null;
  if (!relatedTable) return null;

  const relatedSearch: { [x: string]: string | object } = {};

  if (searches && searches?.length > 0) {
    searches?.forEach((search) => {
      const keyFound = Object.keys(search).find((key) => key === relatedTable);

      if (keyFound) {
        if (isLikeOperator) {
          relatedSearch[overrideColumn ?? keyFound] = {
            [sequelizeOperatorsAliases.like]: `%${search[keyFound]}%`,
          };
        } else {
          relatedSearch[overrideColumn ?? keyFound] = search[keyFound];
        }
      }
    });
  }

  if (Object.keys(relatedSearch).length) return relatedSearch;

  return null;
};

export default getRelatedSearch;
